module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("Introduction"), _c('br'), _c('i', [_vm._v("The Rhetoric of Christian Witness")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_vm._v("1 Preparing the Way"), _c('br'), _c('i', [_vm._v("C. S. Lewis and the Goodwill of Advent")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Professing the Creeds"), _c('br'), _c('i', [_vm._v("Dorothy L. Sayers and the Energy of Christmastide")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Preaching the Word"), _c('br'), _c('i', [_vm._v("Dietrich Bonhoeffer and Epiphanic Identification")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Calling for Repentance"), _c('br'), _c('i', [_vm._v("Desmond Tutu and Lenten Constitutive Rhetorics")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Hosting the Guest"), _c('br'), _c('i', [_vm._v("Marilynne Robinson and the")]), _vm._v(" "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("Ēthos")]), _vm._v(" "), _c('i', [_vm._v("of Eastertide")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Speaking in Tongues"), _c('br'), _c('i', [_vm._v("The Church and the Heteroglossia of Pentecost")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-001a"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "33%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "33%"
    }
  }), _c('col', {
    staticStyle: {
      "padding": "7px"
    }
  })]), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen4#appen-001",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Bibliography")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen5#appen-002",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("General Index")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen6#appen-003",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Scripture Index")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-001b"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "50%"
    }
  }), _c('col', {
    staticStyle: {
      "padding": "7px"
    }
  })]), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen8#appen-004",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Praise for"), _c('i', [_vm._v(" Seasoned Speech")])])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen9#appen-005",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("About the Author")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0